module.exports = __webpack_public_path__ + "img/4.42e6052a.png";